import { render, staticRenderFns } from "./v-sidebar.vue?vue&type=template&id=3c04d2c3&scoped=true"
import script from "./v-sidebar.vue?vue&type=script&lang=js"
export * from "./v-sidebar.vue?vue&type=script&lang=js"
import style0 from "./v-sidebar.vue?vue&type=style&index=0&id=3c04d2c3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04d2c3",
  null
  
)

export default component.exports